// SignIn.js
import React from 'react';
import {
  AppBar, Toolbar, Typography, Container, CssBaseline, ThemeProvider,
  Box, Button
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import logo from '../logo.png';
import './styles.css';
import Footer from '../pages/Footer';
import { 
  generateCodeVerifier, 
  generateCodeChallenge, 
  storePKCEState,
  validatePKCE 
} from '../utils/pkce';

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(18,82,166)',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});

export default function SignIn() {
  const handleSignIn = () => {
    try {
      // Generate proper PKCE parameters
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = generateCodeChallenge(codeVerifier);
      const state = crypto.randomUUID(); // Use crypto.randomUUID() for better security
      
      // Validate PKCE parameters before proceeding
      if (!validatePKCE(codeVerifier, codeChallenge)) {
        console.error('❌ PKCE validation failed, aborting authentication');
        return;
      }
      
      // Store PKCE state securely
      storePKCEState(codeVerifier, state);
      
      console.log('🚀 Starting Fayda SSO with PKCE:', {
        codeVerifierLength: codeVerifier.length,
        codeChallengeLength: codeChallenge.length,
        stateLength: state.length
      });

      const CLIENT_ID = '419258';
      const REDIRECT_URI = 'http://localhost:3000/callback';
      const AUTHORIZATION_ENDPOINT = 'https://esignet.ltsstaging.fayda.et/authorize';
      const SCOPE = 'openid profile email';
      const ACR_VALUES = 'mosip:idp:acr:generated-code:biometrics';

      const claims = {
        userinfo: {
          name: { essential: true },
          phone_number: { essential: true },
          email: { essential: true },
          picture: { essential: true },
          gender: { essential: true },
          birthdate: { essential: true },
          address: { essential: true },
        },
      };

      const encodedClaims = encodeURIComponent(JSON.stringify(claims));

      const authUrl = `${AUTHORIZATION_ENDPOINT}?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(
        REDIRECT_URI
      )}&scope=${encodeURIComponent(SCOPE)}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256&acr_values=${ACR_VALUES}&claims=${encodedClaims}`;

      console.log('🔗 Redirecting to Fayda:', authUrl.substring(0, 100) + '...');
      window.location.href = authUrl;
      
    } catch (error) {
      console.error('❌ Error in Fayda authentication:', error);
      alert('Authentication error. Please try again.');
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="page-container">
        <CssBaseline />
        <AppBar position="static">
          <Toolbar>
            <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Ministry of Education
            </Typography>
          </Toolbar>
        </AppBar>

        <Container component="main" sx={{ maxWidth: 'lg' }}>
          <CssBaseline />

          <Typography component="h1" variant="h5" align="center" sx={{ mt: 6 }}>
            Ethiopian University Exit Exam (EUEE) Registration
          </Typography>

          <Typography component="p" align="center" sx={{ mt: 2 }}>
            Follow Registration guide <a href="https://youtu.be/4ygxMMcrEcg">here (Video)</a>
          </Typography>

          <Box sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" color="primary" size="large" onClick={handleSignIn}>
              Authenticate with Fayda
            </Button>
          </Box>
        </Container>

        <Footer />
      </div>
    </ThemeProvider>
  );
}
